import type {FieldError, Valid} from 'schemaDefinition/types';

export const toFieldError = (valid: Valid): FieldError => {
  return valid === 'valid' ? false : valid === 'warning' ? 'warning' : true;
};
